<section class="default-section-last homepage-section homepage-section--default p-md-4 p-3 pt-5">
    <div class="container">
        <section class="row">
            <article class="homepage-section__column text-center col-12">
                <p class="mb-2">Connect with us on our social media accounts</p>
                <div class="homepage-section__social-links d-flex-center-center">
                    <ng-container *ngFor="let socialMediaLink of partner?.socialMediaLinks">
                        <fitscovery-ui-social-media-link *ngIf="socialMediaLink?.url" class="px-1" [socialMediaLink]="socialMediaLink" [url]="partner?.contactInfo!.email"
                        [isRound]="true" [isSmall]="true"></fitscovery-ui-social-media-link>
                    </ng-container>
                    <!-- <a *ngIf="partner.contactInfo.email" [href]="'mailto:'+ partner.contactInfo.email">
                        <span>
                            <img src="https://d3uee0gs4p7cty.cloudfront.net/social-media-icons/mail_v2.png"
                                class="social-media-logo-mail px-1 py-1" [ngClass]="{'smaller': isSmall}" title="Email Us">
                        </span>
                    </a> -->
                </div>
            </article>
        </section>
    </div>
</section>